/**
 * @file 文档入口
 * @author wanzhongyun
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import 'element-qsa-scope';
import React from 'react';
import ReactDOM from 'react-dom';

import DocRoute from './DocRoute';

import './style/index.less';



ReactDOM.render(<DocRoute />, document.getElementById('root'));


